<script>
	import authBase from '@_system/components/auth/index.vue'
	export default {
		extends: authBase,
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
			title: {
				type: String,
				default: () => {
					return '授权'
				}
			},
			authtab: {
				type: Array,
				default: () => {
					return ['staff','formitem']
				}
			},
			isauth: {
				type: Boolean,
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				name: 'auth',
				activeName: this.authtab[0],
				store: {},
				fApi: {},
				modalShow: false,
				loading: true,
				width: '0',
				height: '0',
				num: {
					department: 0,
					staff: 0,
					postjob: 0,
					joblevel: 0,
					group: 0
				}

			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			//console.log(this.id, this.extra.type)
		},
		mounted() {
		
		},
		methods: {
			show() {
				this.sourcedata = this.extra.value
				if(this.sourcedata){
					this.initdata()
				}
				this.loading = false
			},
			submit() {
				let formData = {
					auth: this.initsubmitdata()
				}
				this.$emit('submit', {
					data: formData.auth
				})
				this.back()
			},
			back(type) {
				this.$emit('back', {
					type: type
				})
			},

		},
		components: {

		}
	}
</script>
